// extracted by mini-css-extract-plugin
module.exports = {"container":"v_lodging_content_container_container__22bEx"};